import { render, staticRenderFns } from "./CnHome.vue?vue&type=template&id=012c4c60&scoped=true&"
import script from "./CnHome.vue?vue&type=script&lang=js&"
export * from "./CnHome.vue?vue&type=script&lang=js&"
import style0 from "./CnHome.vue?vue&type=style&index=0&id=012c4c60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012c4c60",
  null
  
)

export default component.exports